import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getAgentLoginLogoutInformations, getAllRoles } from 'src/store/slices/generalMonitoringSlice';
import {
  BAR,
  ChartSkeleton,
  LegendRow,
  MonitorCard,
  MultiSelectFilter,
  RingChart,
  SECOND,
  SECOND_TRACK,
  TRACK,
  formatNumber,
  formatPercent
} from 'src/components/monitoring/MonitoringParts';

// Profil tipine göre kullanıcı sayısı, bugün giriş yapan ve şu an aktif kullanıcılar
function LoginLogoutInformationChart() {
  const dispatch = useDispatch();
  const [mainData, setMainData] = useState([]);
  const [roleTypes, setRoleTypes] = useState([]);
  const [selectedRoleType, setSelectedRoleType] = useState([]);
  const [loading, setLoading] = useState(true);

  const GetAgentLoginLogoutInformations = (RoleId) => {
    setLoading(true);
    dispatch(getAgentLoginLogoutInformations(RoleId))
      .then((response) => {
        setMainData(Array.isArray(response?.payload) ? response.payload : []);
        setLoading(false);
      })
      .catch(() => {
        setMainData([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    dispatch(getAllRoles())
      .then((response) => setRoleTypes(Array.isArray(response?.payload) ? response.payload : []))
      .catch(() => {});
    GetAgentLoginLogoutInformations('0');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Seçim boşsa tümü ('0')
  const handleSearchData = () => {
    const ids = (selectedRoleType || []).map((row) => row.Id);
    GetAgentLoginLogoutInformations(ids.length ? ids.toString() : '0');
  };

  const row = mainData?.[0] || {};
  const total = Number(row.KULLANICISAYISI) || 0;
  const daily = Number(row.GUNLUKAKTIFADET) || 0;
  const now = Number(row.ANLIKAKTIFADET) || 0;

  return (
    <MonitorCard
      title="Kullanıcı Aktivitesi"
      subtitle="Günlük giriş çıkış bilgileri"
      action={
        <MultiSelectFilter
          label="Profil tipi (tümü)"
          options={roleTypes}
          value={selectedRoleType}
          onChange={setSelectedRoleType}
          onApply={handleSearchData}
          disabled={loading}
        />
      }
    >
      {loading ? (
        <ChartSkeleton height={180} />
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
          <RingChart
            centerValue={formatNumber(total)}
            centerLabel="kullanıcı"
            rings={[
              { label: 'Bugün giriş yapan', value: daily, total, color: BAR, track: TRACK },
              { label: 'Şu an aktif', value: now, total, color: SECOND, track: SECOND_TRACK }
            ]}
          />
          <Box sx={{ flex: 1, minWidth: 200 }}>
            <LegendRow color="#b0bec5" label="Kullanıcı sayısı" value={formatNumber(total)} />
            <LegendRow color={BAR} label="Bugün giriş yapan" value={formatNumber(daily)} share={formatPercent(daily, total)} />
            <LegendRow color={SECOND} label="Şu an aktif" value={formatNumber(now)} share={formatPercent(now, total)} />
          </Box>
        </Box>
      )}
    </MonitorCard>
  );
}

export default LoginLogoutInformationChart;
